var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "caixa-especies"
  }, [_c('h3', {
    staticClass: "caixa-especies-titulo"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._l(_vm.especiesVisiveis, function (pagamento) {
    return _c('div', {
      key: pagamento.key,
      staticClass: "caixa-especies-linha"
    }, [_c('span', [_vm._v(_vm._s(pagamento.descricao) + " R$")]), _c('strong', [_vm._v(_vm._s(_vm.formatarValor(pagamento.total)))])]);
  }), !_vm.especiesVisiveis.length ? _c('p', {
    staticClass: "caixa-especies-vazio"
  }, [_vm._v(" " + _vm._s(_vm.mensagemVazia) + " ")]) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };